import ConfigureAcomba from './ConfigureAcomba';
import ConnectToQuickbooks from '../../components/ConnectToQuickbooks/ConnectToQuickbooks';
import type { IntegrationTypes } from '@progyconnect/webapp-types';
import { State } from '../../redux/state';
import { useSelector } from 'react-redux';

const WizardConfigure = () => {
    const integrationType = useSelector<State, IntegrationTypes | undefined>((state) => state.config?.type);

    if (integrationType?.startsWith('Qbo')) return <ConnectToQuickbooks />;
    if (integrationType?.startsWith('Acomba')) return <ConfigureAcomba waitForConnection={true} />;

    return <>Unsupported integration type</>;
};

export default WizardConfigure;
